import { Component, OnInit, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { format } from 'date-fns'

@Component({
  selector: 'app-modal-view-movimiento',
  templateUrl: './modal-view-movimiento.component.html',
  styleUrls: ['./modal-view-movimiento.component.scss']
})
export class ModalViewMovimientoComponent implements OnInit {

  // Modales
  @ViewChild('consultaMovimiento', { static: true }) modalViewMovimiento: ModalDirective

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  optionsBodega: Array<any> = [];
  optionsMotivo: Array<any> = [];
  codigoMovimiento: number = -1
  headerData: any = null
  detailsData: any = null
  detailsResumen: any = null

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService
  ) {
    this.log = this.clog.log('INVENTARIO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
  }

  /********* SHOW/HIDE *********/
  show() {
    this.modalViewMovimiento.show();
  }

  hide() {
    this.modalViewMovimiento.hide();
  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/
  get showBodegaEntrada() {
    if (!this.headerData) return false
    // return this.headerData.tipo_movimiento_codigo === 1 || this.headerData.tipo_movimiento_codigo === 2
    return this.headerData.bodega_nombre_ingreso && this.headerData.bodega_nombre_ingreso.trim().length > 0
  }

  get showBodegaSalida() {
    if (!this.headerData) return false
    // return this.headerData.tipo_movimiento_codigo === -1 || this.headerData.tipo_movimiento_codigo === 2
    return this.headerData.bodega_nombre_salida && this.headerData.bodega_nombre_salida.trim().length > 0
  }

  load(rut_emisor, codigo) {
    this.log(codigo)

    this.codigoMovimiento = codigo
    const _variables = {
      rut_emisor: rut_emisor,
      sucursal_codigo: this.sucursalEmpresa,
      codigo: codigo
    }

    const self = this
    this.gqlclient.query(
      {
        query: gql`
          query
            (
              $rut_emisor: Decimal,
              $sucursal_codigo: Decimal,
              $codigo: Decimal
            )
            {
              movimiento_stock {
                obtenerEncaMovimientoStockSegunFiltros(filtro: {exacto: {
                  rut_emisor: $rut_emisor,
                  sucursal_codigo: $sucursal_codigo
                  codigo: $codigo,
                }}) {
                  mensajes {
                    tipo
                    texto
                    codigo
                    contexto
                  }
                  respuesta {
                    registros {
                      codigo
                      fecha_movimiento
                      tipo_movimiento_codigo
                      tipo_movimiento_nombre
                      bodega_codigo_ingreso
                      bodega_nombre_ingreso
                      bodega_codigo_salida
                      bodega_nombre_salida
                      referencia
                      rut_emisor
                      rut_usuario
                      nombre_usuario_registro
                      costo_total
                      periodo_anno_mes
                    }
                  }
                }
                obtenerDetalleMovimientoStockSegunFiltros(filtro: {exacto: {
                  rut_emisor: $rut_emisor,
                  sucursal_codigo: $sucursal_codigo
                  codigo: $codigo,
                }}) {
                  mensajes {
                    tipo
                    texto
                    codigo
                    contexto
                  }
                  respuesta {
                    registros {
                      codigo
                      rut_emisor
                      sucursal_codigo
                      producto_codigo
                      sku
                      producto_descripcion
                      formato_codigo
                      formato_nombre
                      cantidad
                      precio_costo
                      costo_total
                      listaStockxUnidadesxBodega {
                        formato_codigo
                        cantidad
                        producto_codigo
                        formato_codigo_top
                        formato_secundario
                        empresa_rut
                        nombre_formato
                        cantidad_formato
                        bodega_codigo
                      }
                    }
                  }
                }
              }
            }

         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        self.log(response)
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes: mensajeHeader, respuesta: respHeader } = response.data.movimiento_stock.obtenerEncaMovimientoStockSegunFiltros
        const { registros: headerData } = respHeader
        self.headerData = headerData[0]
        // self.headerData.mesanhoProceso = format(new Date(self.headerData.fecha_movimiento), 'MM-yyyy')

        const { mensajes: mensajesDetails, respuesta: respDetalles } = response.data.movimiento_stock.obtenerDetalleMovimientoStockSegunFiltros
        const { registros: detailsData } = respDetalles
        self.detailsData = detailsData

        self.calcularTotales()

        self.show()
      }
    );
  }

  calcularTotales() {
    this.detailsResumen = {}
    this.detailsResumen.cantidad = this.detailsData.reduce((prev, cur) => prev + this.getCantidadFormato(cur), 0);
    this.detailsResumen.subtotal = this.detailsData.reduce((prev, cur) => prev + cur.precio_costo, 0);
    this.detailsResumen.total = this.detailsData.reduce((prev, cur) => prev + cur.costo_total, 0);
    this.log(this.detailsResumen)
  }

  getCantidadFormato(movimiento: any): number {
    // Si no existe listaStockxUnidadesxBodega, usar cantidad normal
    if (!movimiento.listaStockxUnidadesxBodega || movimiento.listaStockxUnidadesxBodega.length === 0) {
      return movimiento.cantidad || 0;
    }

    // Buscar el formato exacto (case insensitive)
    const formato = movimiento.listaStockxUnidadesxBodega.find(item =>
      item.formato_codigo &&
      item.formato_codigo.toLowerCase() === movimiento.formato_codigo.toLowerCase()
    );

    if (formato) {
      // Siempre usar cantidad_formato directamente de los datos
      console.log('UXE para', movimiento.sku, movimiento.formato_codigo, ':', formato.cantidad_formato);
      return formato.cantidad_formato || 1;
    }

    console.log('No se encontró formato para', movimiento.sku, movimiento.formato_codigo);
    // Si no encuentra el formato, devolver 1 por defecto
    return 1;
  }

  imprimir() {
    // Crear una nueva ventana para imprimir solo el contenido del modal
    const printContent = this.generatePrintContent();
    const printWindow = window.open('', '_blank', 'width=800,height=600');

    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.focus();

      // Esperar a que se cargue el contenido y luego imprimir
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    } else {
      // Fallback si no se puede abrir ventana nueva
      this.imprimirEnMismaVentana();
    }
  }

  private generatePrintContent(): string {
    const fechaMovimiento = this.headerData.fecha_movimiento;
    const nroMovimiento = this.headerData.codigo;
    const tipoMovimiento = this.headerData.tipo_movimiento_nombre;
    const bodegaIngreso = this.headerData.bodega_nombre_ingreso || '';
    const bodegaSalida = this.headerData.bodega_nombre_salida || '';
    const referencia = this.headerData.referencia || '';
    const usuarioRegistroText = this.headerData.nombre_usuario_registro
      ? this.headerData.nombre_usuario_registro
      : (this.headerData.rut_usuario != null && Number(this.headerData.rut_usuario) > 0
        ? `rut ${this.formatNumber(Number(this.headerData.rut_usuario))}`
        : '—');

    let filas = '';
    this.detailsData.forEach(item => {
      filas += `
        <tr>
          <td>${item.sku}</td>
          <td>${item.producto_descripcion}</td>
          <td>${item.formato_nombre}</td>
          <td style="text-align: right">${this.formatNumber(item.cantidad)}</td>
          <td style="text-align: right">${this.formatNumber(item.precio_costo)}</td>
          <td style="text-align: right">${this.formatNumber(item.costo_total)}</td>
        </tr>
      `;
    });

    const bodegaIngresoSection = this.showBodegaEntrada ?
      `<div style="margin-right: 20px;"><strong>Bodega ingreso:</strong> ${bodegaIngreso}</div>` : '';

    const bodegaSalidaSection = this.showBodegaSalida ?
      `<div style="margin-right: 20px;"><strong>Bodega salida:</strong> ${bodegaSalida}</div>` : '';

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Consulta Movimiento de inventario</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            font-size: 12px;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
            border-bottom: 2px solid #333;
            padding-bottom: 10px;
          }
          .info-section {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 20px;
            gap: 20px;
          }
          .info-item {
            margin-right: 20px;
          }
          .referencia-section {
            margin-bottom: 20px;
            padding: 10px;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }
          .totals-row {
            background-color: #e3f2fd;
            font-weight: bold;
          }
          .text-right {
            text-align: right;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h2>Consulta Movimiento de inventario</h2>
        </div>

        <div class="info-section">
          <div class="info-item"><strong>Fecha de movimiento:</strong> ${this.formatDate(fechaMovimiento)}</div>
          <div class="info-item"><strong>Nro. movimiento:</strong> ${nroMovimiento}</div>
          <div class="info-item"><strong>Tipo Movimiento:</strong> ${tipoMovimiento}</div>
          <div class="info-item"><strong>Usuario registro:</strong> ${usuarioRegistroText}</div>
          ${bodegaIngresoSection}
          ${bodegaSalidaSection}
        </div>

        <div class="referencia-section">
          <strong>Referencia:</strong> ${referencia}
        </div>

        <table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>Producto</th>
              <th>Formato</th>
              <th class="text-right">Cantidad</th>
              <th class="text-right">Costo Unitario</th>
              <th class="text-right">Costo total</th>
            </tr>
          </thead>
          <tbody>
            ${filas}
          </tbody>
          <tbody>
            <tr class="totals-row">
              <td colspan="3" class="text-right"><strong>Totales</strong></td>
              <td class="text-right"><strong>${this.formatNumber(this.detailsResumen.cantidad)}</strong></td>
              <td class="text-right"><strong></strong></td>
              <td class="text-right"><strong>${this.formatNumber(this.detailsResumen.total)}</strong></td>
            </tr>
          </tbody>
        </table>
      </body>
      </html>
    `;
  }

  private imprimirEnMismaVentana() {
    const originalContent = document.body.innerHTML;
    const printContent = this.generatePrintContent();

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;

    // Recargar la página para restaurar la funcionalidad
    window.location.reload();
  }

  private formatNumber(num: number): string {
    return new Intl.NumberFormat('es-CL').format(num);
  }

  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('es-CL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }
  /********* OPERATIONS *********/


}
